// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash/fp';

// Utils
import {
    getNotificationBoardTitle,
    getNotificationElementId,
} from '../../../../../../../common/notifications/notificationModelUtils';

// Components
import BaseNotificationEntry from './BaseNotificationEntry';
import UserNames from './UserNames';
import Icon from '../../../../../../components/icons/Icon';
import NotificationUserFigure from './NotificationFigureUser';
import { getTitle } from '../../../../../../../common/elements/utils/elementPropertyUtils';

const BoardTitle = (props) => {
    const { group, element, notification } = props;

    const groupId = get('id', group);
    const boardId = getNotificationElementId(notification);

    if (groupId === boardId) return <span>this board</span>;

    const boardTitle = getTitle(element) || getNotificationBoardTitle(notification);

    if (!boardTitle) return <span>a board</span>;

    return <span className="board-title">{boardTitle}</span>;
};

const NotificationEntryUnshare = (props) => {
    const { actors } = props;

    return (
        <BaseNotificationEntry
            {...props}
            className="NotificationEntryUnshare"
            figure={<NotificationUserFigure {...props} icon={<Icon name="notification-unshare" />} />}
        >
            <div className="notification-statement">
                <UserNames users={actors} /> removed your access to <BoardTitle {...props} />
            </div>
        </BaseNotificationEntry>
    );
};

BoardTitle.propTypes = NotificationEntryUnshare.propTypes = {
    element: PropTypes.object,
    group: PropTypes.object,
    actors: PropTypes.array,
    notification: PropTypes.object,
    previousLastCheckedNotifications: PropTypes.number,
};

export default NotificationEntryUnshare;
